import { render, staticRenderFns } from "./SuppliersBalance.vue?vue&type=template&id=9ccd72b8&scoped=true&"
import script from "./SuppliersBalance.vue?vue&type=script&lang=js&"
export * from "./SuppliersBalance.vue?vue&type=script&lang=js&"
import style0 from "./SuppliersBalance.vue?vue&type=style&index=0&id=9ccd72b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ccd72b8",
  null
  
)

export default component.exports